module.exports = __webpack_public_path__ + "static/mieszkania-na-sprzedaz-puck-43395b538adaa0156587de75fd942547.jpg";